const Constants = Object.freeze({
  // ---------------------------- Backend IP ----------------------------
  REQUEST_IP_ADDRESS: `${window.location.origin}${process.env.PUBLIC_URL}/api/`,
  //REQUEST_IP_ADDRESS: "http://localhost:5000/",

  // ---------------------------- Language ----------------------------
  LOCAL_STORAGE_KEY: "mn-pn-language",
  LL_ACTIVE_COLUMNS: "ll-act-col",
  ES_LANG_KEY: "es",
  EN_LANG_KEY: "en",
  PT_LANG_KEY: "pt",
  DE_LANG_KEY: "de",

  // ---------------------------- Wifi / Ethernet ----------------------------
  WIFI_OR_ETHENET_KEY: "wifi-eth",

  //  ---------------------------- Device Status ----------------------------
  OK: "ok",
  DIAGNOSTIC: "diagnostic",
  FAULT: "fault",
  ONLINE: "online",
  OFFLINE: "offline",
  NONE: "None",
  ENTRY: "entry",
  CONFIG_ERROR: "errorConfig",
  DUPLICATE_IP: "duplicated",

  // ---------------------------- Alarms ----------------------------
  ALARM_FAILURE: "Failure",
  ALARM_MAINTENANCE_REQUIRED: "Maintenance required",
  ALARM_MAINTENANCE_DEMANDED: "Maintenance demanded",
  ALARM_NONE: "Maintenance not informed",

  // ---------------------------- Page Scaling Modifiers ----------------------------
  PAGE_HEGHT_MODIFIER: 0.7,
  SCALING_FACTOR_LIVE_TOPOLOGY: 0.60,
  SCALING_FACTOR_INVENTORY: 0.58,
  SCALING_FACTOR_TRAFFIC: 0.48,
  SCALING_FACTOR_LOG: 0.54,
  SCALING_FACTOR_PORTS: 0.48,
  SCALING_FACTOR_PING: 0.56,

  // ---------------------------- Config ----------------------------
  UNKNOWN_UPPERCASE: "UNKNOWN",

  AUTH_STR: "f4610aa514477222afac2b77f971d069780ca2846f375849f3dfa3c0047ebbd1",

  GPG_FILE_EXTENSION: ".gpg",
  XML_FILE_EXTENSION: ".xml",

  // ------------------------------- NTP UPDATE STATUS ----------------------------
  NTP_UPDATE_NOT_STARTED: "notUpdating",
  NTP_UPDATE_START: "start",
  NTP_UPDATE_SUCCESS: "sucess",
  NTP_UPDATE_FAIL: "fail",

  NOT_UPDATING: "notUpdating",
  UPDATE_FILES_FOUND: "updateFilesFound",
  FINISHED_UPDATING: "finishedUpdating",
  RESTARTING_MONITOR: "restartingMonitor",

  FILE_UPDATE_TYPE: "file-update",
  INTERFACE_CONFIG_UPDATE_TYPE: "interface-config-update",
  NTP_UPDATE_TYPE: "turnNtpOn",

  TS_MONITOR_VERSION: "6.3.0",

  OVERVIEW_DOTS: ".................................................................................................................................",
  LIVE_LIST_DOTS: "......................................................................................................................................",
  INVENTORY_DOTS: "...................................................................................................................................",
  TOPOLOGY_DOTS: "...................................................................................................................................",
  IN_TRAFFIC_ERRORS_DOTS: "......................................................................................................",
  OUT_TRAFFIC_ERRORS_DOTS: "..........................................................................................................",
  MON_LOG_DOTS: ".................................................................................................................................................",
  DISCLAIMER_DOTS: "..............................................................................................................................",
  DISCLAIMER_DOTS_2: ".....................................................................................................................................",

  MAX_NUM_OF_LOG_EVENTS: 200,

  CONFORM: "conform",
  NON_CONFORM: "nonConform",
  CONFORM_W_RESTRICTION: "conformRestriction",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  GRAPHIC_TOPOLOGY_REFRESH_TIME: 15000,

  WEB_DEFAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/web-page-default.png`,

  ROLE_IO_CONTROLLER: "IO-Controller",
  ROLE_IO_DEVICE: "IO-Device",
  ROLE_IO_SUPERVISOR: "IO-Supervisor",
  ROLE_HMI: "HMI",

  IO_CONTROLLER_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-controller-ok.png`,
  IO_CONTROLLER_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-controller-diagnostic.png`,
  IO_CONTROLLER_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-controller-fault.png`,
  IO_CONTROLLER_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-controller-blacklist.png`,
  IO_CONTROLLER_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-controller-config-error.png`,

  IO_DEVICE_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-device-ok.png`,
  IO_DEVICE_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-device-diagnostic.png`,
  IO_DEVICE_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-device-fault.png`,
  IO_DEVICE_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-device-blacklist.png`,
  IO_DEVICE_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-device-config-error.png`,

  IO_SUPERVISOR_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/supervisor-ok.png`,
  IO_SUPERVISOR_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/supervisor-diagnostic.png`,
  IO_SUPERVISOR_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/supervisor-fault.png`,
  IO_SUPERVISOR_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/supervisor-blacklist.png`,
  IO_SUPERVISOR_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/supervisor-config-error.png`,

  SWITCH_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch-ok.png`,
  SWITCH_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch-diagnostic.png`,
  SWITCH_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch-fault.png`,
  SWITCH_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch-blacklist.png`,
  SWITCH_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch-config-error.png`,

  DRIVE_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/drive-ok.png`,
  DRIVE_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/drive-diagnostic.png`,
  DRIVE_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/drive-fault.png`,
  DRIVE_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/drive-blacklist.png`,
  DRIVE_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/drive-config-error.png`,

  WIRELESS_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless-ok.png`,
  WIRELESS_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless-diagnostic.png`,
  WIRELESS_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless-fault.png`,
  WIRELESS_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless-blacklist.png`,
  WIRELESS_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless-config-error.png`,

  HMI_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi-ok.png`,
  HMI_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi-diagnostic.png`,
  HMI_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi-fault.png`,
  HMI_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi-blacklist.png`,
  HMI_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi-config-error.png`,

  // ---------------------------- BLACKLIST ----------------------------
  BLACKLIST_TIMEOUT: 2000,

  // ---------------------------- WLAN Config ----------------------------
  CONNECTED_STATUS: "connected",
  DISCONNECTED_STATUS: "disconnected",
  DHCP_MODE: "dhcp",
  FIXED_IP_MODE: "fixedIp",

  // ---------------------------- TS EXPERT ERROR TYPES ----------------------------
  DIAGNOSTIC_ERROR_TYPE: "diagnostic",                  // Device com alarme
  FAULT_ERROR_TYPE: "fault",                            // Device com falha
  DUPLICATE_IP_ERROR_TYPE: "duplicatedIp",              // IP duplicado
  DUPLICATE_NAME_ERROR_TYPE: "duplicatedName",          // PROFINAME duplicado
  PING_ERROR_TYPE: "avgPingExceededLimit",              // tempo ping estourado
  DELTA_ERROR_TYPE: "deltaErr",                         // Incremento de erro
  NOT_IN_FULL_DUPLEX_ERROR_TYPE: "wrongMAUType",        // portas diferente de 100M Full Duplex
  TRAFFIC_EXCESS_ERROR_TYPE: "excessKbps",              // Excesso de trÃ¡fego
  INACTIVE_PORT_ERROR_TYPE: "inactivePort",             // porta que caiu
  HW_FW_ERROR_TYPE: "firmwareIncoherence",              // vHW iguais com vFW diferentes
  MODULE_INCOHERENCE_ERROR_TYPE: "moduleIncoherence",   // module incoherence
  DUPLEX_MISMATCH_ERROR_TYPE: "duplexMismatch",         // Duplex mismatch
  DELAY_ERROR_TYPE: "lineDelayExceededLimit",           // Delay Exceeded
  INTERMITENT_FAILURE_ERROR_TYPE: "intermittentFailure",// Intermittent failure
  LOST_IP_ERROR_TYPE: "lostIp",

  // PRO topology compatibility
  ACCESS_POINT_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless.png`,
  DIFF_SUBNET: "diffSubnet",
  DRIVE_DIFF_SUBNET_IMG_PATH: `${process.env.PUBLIC_URL}/images/drive-diff-subnet.png`,
  DRIVE_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/drive-missing.png`,
  ENDPOINT_IMG_PATH: `${process.env.PUBLIC_URL}/images/endpoint.png`,
  FIREWALL_IMG_PATH: `${process.env.PUBLIC_URL}/images/router-firewall.png`,
  HMI_DIFF_SUBNET_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi-diff-subnet.png`,
  HMI_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi.png`,
  HMI_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/hmi-missing.png`,
  IO_CONTROLLER_DIFF_SUBNET_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-controller-diff-subnet.png`,
  IO_CONTROLLER_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-controller-missing.png`,
  IO_DEVICE_DIFF_SUBNET_PATH: `${process.env.PUBLIC_URL}/images/io-device-diff-subnet.png`,
  IO_DEVICE_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/io-device-missing.png`,
  IO_SUPERVISOR_DIFF_SUBNET_IMG_PATH: `${process.env.PUBLIC_URL}/images/supervisor-diff-subnet.png`,
  IO_SUPERVISOR_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/supervisor-missing.png`,
  MISSING: "missing",
  MN_PN_PRO_ACTIVE_PASSIVE_PRODUCT_TYPE: "mn-pn-pro-ativo-passivo",
  PC_IMG_PATH: `${process.env.PUBLIC_URL}/images/pc.png`,
  TAP_IMG_PATH: `${process.env.PUBLIC_URL}/images/tap.png`,
  SELECTED_DEVICE_REFRESH_TIME: 2000,
  SERVER_IMG_PATH: `${process.env.PUBLIC_URL}/images/server.png`,
  SWITCH_DIFF_SUBNET_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch-diff-subnet.png`,
  SWITCH_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch.png`,
  SWITCH_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/switch-missing.png`,
  WIRELESS_DIFF_SUBNET_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless-diff-subnet.png`,
  WIRELESS_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/wireless-missing.png`,
});

export default Constants;
